import { all } from 'redux-saga/effects';
import { adviserDetailsSaga, emulateUserDetailsSaga } from './adviser.saga';
import { getQuickSearchDataSaga } from './search.data.saga';
import { getRecentClientsSaga } from './recent-clients.saga';

export default function* rootSaga() {
	yield all([
		adviserDetailsSaga(),
		emulateUserDetailsSaga(),
		getQuickSearchDataSaga(),
		getRecentClientsSaga(),
	]);
}
